import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F1493F",
  d: "M32.064 18.408a13.014 13.014 0 0 0-3.105-4.314l-1.09-1a.302.302 0 0 0-.487.124l-.487 1.396c-.303.877-.86 1.772-1.651 2.652a.235.235 0 0 1-.153.075.207.207 0 0 1-.161-.057.221.221 0 0 1-.075-.179c.139-2.255-.536-4.798-2.012-7.565-1.22-2.3-2.917-4.093-5.037-5.345l-1.547-.909a.3.3 0 0 0-.45.274l.083 1.797c.056 1.229-.085 2.315-.423 3.217a10.695 10.695 0 0 1-1.76 3.053c-.526.64-1.123 1.22-1.779 1.726a13.205 13.205 0 0 0-3.756 4.551 13.024 13.024 0 0 0-1.356 5.778c0 1.769.348 3.48 1.037 5.095a13.161 13.161 0 0 0 7.018 6.95 13.179 13.179 0 0 0 5.128 1.026 13.25 13.25 0 0 0 5.127-1.022 13.055 13.055 0 0 0 4.19-2.798 12.965 12.965 0 0 0 3.866-9.246 12.893 12.893 0 0 0-1.12-5.279Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }